/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { RegistrySearch200ResponsePagination } from './RegistrySearch200ResponsePagination'
import {
  RegistrySearch200ResponsePaginationFromJSON,
  RegistrySearch200ResponsePaginationFromJSONTyped,
  RegistrySearch200ResponsePaginationToJSON,
} from './RegistrySearch200ResponsePagination'
import type { RegistrySearch200ResponseCounts } from './RegistrySearch200ResponseCounts'
import {
  RegistrySearch200ResponseCountsFromJSON,
  RegistrySearch200ResponseCountsFromJSONTyped,
  RegistrySearch200ResponseCountsToJSON,
} from './RegistrySearch200ResponseCounts'
import type { RegistrySearchItem } from './RegistrySearchItem'
import {
  RegistrySearchItemFromJSON,
  RegistrySearchItemFromJSONTyped,
  RegistrySearchItemToJSON,
} from './RegistrySearchItem'

/**
 *
 * @export
 * @interface RegistrySearch200Response
 */
export interface RegistrySearch200Response {
  /**
   *
   * @type {boolean}
   * @memberof RegistrySearch200Response
   */
  status: boolean
  /**
   *
   * @type {Array<RegistrySearchItem>}
   * @memberof RegistrySearch200Response
   */
  data: Array<RegistrySearchItem>
  /**
   *
   * @type {RegistrySearch200ResponseCounts}
   * @memberof RegistrySearch200Response
   */
  counts?: RegistrySearch200ResponseCounts
  /**
   *
   * @type {RegistrySearch200ResponsePagination}
   * @memberof RegistrySearch200Response
   */
  pagination?: RegistrySearch200ResponsePagination
}

/**
 * Check if a given object implements the RegistrySearch200Response interface.
 */
export function instanceOfRegistrySearch200Response(
  value: object
): value is RegistrySearch200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function RegistrySearch200ResponseFromJSON(
  json: any
): RegistrySearch200Response {
  return RegistrySearch200ResponseFromJSONTyped(json, false)
}

export function RegistrySearch200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): RegistrySearch200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: (json['data'] as Array<any>).map(RegistrySearchItemFromJSON),
    counts:
      json['counts'] == null
        ? undefined
        : RegistrySearch200ResponseCountsFromJSON(json['counts']),
    pagination:
      json['pagination'] == null
        ? undefined
        : RegistrySearch200ResponsePaginationFromJSON(json['pagination']),
  }
}

export function RegistrySearch200ResponseToJSON(
  value?: RegistrySearch200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: (value['data'] as Array<any>).map(RegistrySearchItemToJSON),
    counts: RegistrySearch200ResponseCountsToJSON(value['counts']),
    pagination: RegistrySearch200ResponsePaginationToJSON(value['pagination']),
  }
}
